export const providerKey = 'multiDialog'
